import React from "react";

const Certificate = () => {
  return (
    <>
      <div className="detail-header">
        <h3 id="cert_id">CERTIFICATES</h3>
        <hr />
      </div>
      <div className="projects">
        <div>
          <h4>Introduction to Data Analytics</h4>
          <a
            alt="Data analytics certificate"
            href="./assets/IntroductionDataAnalytics.png"
            target={"blank"}
          >
            <img
              src="./assets/IntroductionDataAnalytics.png"
              alt="Data analytics certificate"
            />
          </a>
        </div>
        <div>
          <h4>Excel Basics for Data Analysis</h4>
          <a
            alt="Basics with excel certificate"
            href="./assets/excelBasics.png"
            target={"blank"}
          >
            <img src="./assets/excelBasics.png" alt="Basics with excel" />
          </a>
        </div>
        <div>
          <h4>Introduction to R programming</h4>
          <a alt="R certificate" href="./assets/R.png" target={"blank"}>
            <img src="./assets/R.png" alt="R certificate" />
          </a>
        </div>
        <div>
          <h4>SQL for Data Science</h4>
          <a alt="SQL certificate" href="./assets/SQL.png" target={"blank"}>
            <img src="./assets/SQL.png" alt="SQL certificate" />
          </a>
        </div>
        <div>
          <h4>Introduction to Python</h4>
          <a
            alt="Python certificate"
            href="./assets/python.png"
            target={"blank"}
          >
            <img src="./assets/python.png" alt="Python certificate" />
          </a>
        </div>
        <div>
          <h4>Introduction to IoT</h4>
          <a alt="IoT certificate" href="./assets/IoT.png" target={"blank"}>
            <img src="./assets/IoT.png" alt="IoT certificate" />
          </a>
        </div>
        <div>
          <h4>Tableau Fundamentals</h4>
          <a
            alt="Tableau certificate"
            href="./assets/TableauFundamentals.png"
            target={"blank"}
          >
            <img
              src="./assets/TableauFundamentals.png"
              alt="Tableau certificate"
            />
          </a>
        </div>
        <div>
          <h4>Getting started with Power BI</h4>
          <a
            alt="PowerBI certificate"
            href="./assets/PowerBI.png"
            target={"blank"}
          >
            <img src="./assets/PowerBI.png" alt="PowerBI certificate" />
          </a>
        </div>
        <div>
          <h4>PowerBi report development</h4>
          <a
            alt="PowerBI report certificate"
            href="./assets/PowerBIcrashCourse.png"
            target={"blank"}
          >
            <img
              src="./assets/PowerBIcrashCourse.png"
              alt="PowerBI report certificate"
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default Certificate;
